import { Dialog, DialogContent } from '@mui/material'
import BusinessIcon from '@mui/icons-material/Business'
import PersonIcon from '@mui/icons-material/Person'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useNavigate } from 'react-router-dom'
import { Button } from 'ui'
import style from './UserTypeSelectionModal.module.scss'

type UserTypeSelectionModalProps = {
  open: boolean
  onClose: () => void
  // если передан — вызывается вместо navigate (для страницы заказа)
  onSelect?: (type: 'personal' | 'company') => void
}

/**
 * Модальное окно выбора типа пользователя при авторизации
 * Позволяет выбрать между физическим и юридическим лицом
 */
export function UserTypeSelectionModal({
  open,
  onClose,
  onSelect,
}: UserTypeSelectionModalProps) {
  const navigate = useNavigate()

  const handleSelectIndividual = () => {
    if (onSelect) {
      onSelect('personal')
    } else {
      onClose()
      navigate('/login')
    }
  }

  const handleSelectCompany = () => {
    if (onSelect) {
      onSelect('company')
    } else {
      onClose()
      navigate('/company/login')
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      className={style.dialog}
    >
      <h1 className={style.dialog__title}>Выберите тип пользователя</h1>
      <DialogContent className={style.dialog__content}>
        <div className={style.dialog__options}>
          {/* Физическое лицо */}
          <div
            className={style.dialog__option}
            onClick={handleSelectIndividual}
            data-testid='user-type-individual'
          >
            <div className={style.dialog__optionIcon}>
              <PersonIcon fontSize='large' />
            </div>
            <div className={style.dialog__optionContent}>
              <h3 className={style.dialog__optionTitle}>Физическое лицо</h3>
              <p className={style.dialog__optionDescription}>
                Для частных клиентов
              </p>
            </div>
            <ChevronRightIcon className={style.dialog__optionArrow} />
          </div>

          {/* Юридическое лицо */}
          <div
            className={style.dialog__option}
            onClick={handleSelectCompany}
            data-testid='user-type-company'
          >
            <div className={style.dialog__optionIcon}>
              <BusinessIcon fontSize='large' />
            </div>
            <div className={style.dialog__optionContent}>
              <h3 className={style.dialog__optionTitle}>Юридическое лицо</h3>
              <p className={style.dialog__optionDescription}>
                Для организаций и ИП
              </p>
            </div>
            <ChevronRightIcon className={style.dialog__optionArrow} />
          </div>
        </div>

        <Button
          variant='text'
          onClick={onClose}
          className={style.dialog__cancelButton}
          data-testid='user-type-cancel'
        >
          Отмена
        </Button>
      </DialogContent>
    </Dialog>
  )
}
